export default __webpack_public_path__ + "static/media/curators.657b343b.svg";